import React from 'react';
import './PageHeader.scss';

const PageHeader = ({ title, subtitle }) => {
  return (
    <div className="page-header">
      <h1 className="page-title">{title}</h1>
      <h2 className="page-subtitle">{subtitle}</h2>
    </div>
  );
};

export default PageHeader;